module.exports = __webpack_public_path__ + "static/CONTACT-ba03077d23ad94b10ba62ccba34a0eb0.svg";